var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoreHorizonIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8163 9.63356C21.0205 9.63356 22 10.6125 22 11.8169C22 13.0206 21.0205 14.0002 19.8163 14.0002C18.6121 14.0002 17.6327 13.0207 17.6327 11.8169C17.6327 10.6125 18.6121 9.63356 19.8163 9.63356Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.123 9.63356C13.3272 9.63356 14.3066 10.6125 14.3066 11.8169C14.3066 13.0206 13.3272 14.0002 12.123 14.0002C10.919 14.0002 9.93933 13.0207 9.93933 11.8169C9.93938 10.6125 10.919 9.63356 12.123 9.63356Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.18353 9.63356C5.38752 9.63356 6.36719 10.6125 6.36719 11.8169C6.36719 13.0206 5.38757 14.0002 4.18353 14.0002C2.9795 14.0002 1.99988 13.0207 1.99988 11.8169C1.99988 10.6125 2.9795 9.63356 4.18353 9.63356Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreHorizonIcon);
export default __webpack_public_path__ + "static/media/more_horizon_icon.dcdcf002.svg";
export { ForwardRef as ReactComponent };